// extracted by mini-css-extract-plugin
export default {"emailPreviewTitle":"EmailPreview_emailPreviewTitle__g4qWU","emailPreviewContent":"EmailPreview_emailPreviewContent__uApCE"};